import { Card } from "react-bootstrap";
import emailVerifyImg from "/imgs/email-verify.png";
import { useSearchParams } from "react-router-dom";
import { Seo } from "../../../components/Seo";
import { generateNoIndexSEO } from "../../../lib/seo/metaGenerators";

const VerificationPage = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  return (
    <div>
      <Seo {...generateNoIndexSEO("Verify Your Email")} />
      <Card className="mt-3">
        <Card.Body>
          <div className="w-full d-flex justify-content-center align-items-center m-4">
            <img src={emailVerifyImg} width={40} height={40} />
          </div>
          <div
            className="w-full d-flex flex-column justify-content-center align-items-center"
            style={{ textAlign: "center" }}
          >
            <Card.Title>Verify your email address</Card.Title>
            <Card.Text>
              You're almost there! We have sent an email to
              <span className="ms-2">
                <a href="#">{email}</a>
              </span>
            </Card.Text>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default VerificationPage;
